import React, { Component } from 'react';
import { Tab, Menu, Item, Label, Icon, Image, Grid, Form, Segment, Button, Checkbox, Modal, Header, Accordion, Divider } from 'semantic-ui-react';
import nl2br from 'react-newline-to-break';
import Slider from "react-slick";


  const tabContentData = require('../json/tabcontent.json');
    const contentIndex = (ref)=>{
      switch(ref){
        case 'about':
          return 0;
        case 'service':
          return 1;
        case 'gallery':
          return 2;
        case 'lab':
          return 3;
        case 'contact':
          return 4;
        default:
          return 0;
      }
    };

   const textarray = (ref)=>{
      var refpara = '<List>';
      for(let i= 0; i<ref.length;i+=1){
        refpara+='<List.Item>'+ref[i]+'</List.Item>';
      }
      return refpara+'</List>';
    };

    const porfessionOptionEn = [
                { "key": 0, "text": "Research", "value": "design" },
                { "key": 1, "text": "Client", "value": "client" },
                { "key": 2, "text": "Consulter", "value": "consulter" },
              ],
                  porfessionOptionTw = [
                { "key": 0, "text": "研究", "value": "design" },
                { "key": 1, "text": "客戶", "value": "client" },
                { "key": 2, "text": "諮詢", "value": "consulter" },
              ],
                  interestOptionEn = [
                { "key": 0, "text": "Design", "value": "design" },
                { "key": 1, "text": "Music", "value": "music" },
                { "key": 2, "text": "Website", "value": "website" },
                { "key": 3, "text": "Programming", "value": "programming" },
                { "key": 4, "text": "Performance", "value": "performance" },
              ],
                  interestOptionTw = [
                { "key": 0, "text": "設計", "value": "design" },
                { "key": 1, "text": "音樂", "value": "music" },
                { "key": 2, "text": "網站", "value": "website" },
                { "key": 3, "text": "程式", "value": "programming" },
                { "key": 4, "text": "表演藝術", "value": "performance" },
              ];

    // CSS = FONT
    const fontFamily={
      fontFamily:'Raleway, Microsoft JhengHei, sans-serif',
      fontWeight: 100,
    }
    const fontResize={
      ...fontFamily,
      fontSize:'0.75em',
      lineHeight: '1.25',
    }
 
    // CSS = STYLE
    const divStyle={
      margin: 0,
    };
    const tabStyle = {
      ...fontFamily,
      position: 'absolute',
      top: '20%',
      left:'10%',
      width: '80%',
      height: '60vh',
      justifyContent: 'center',
      overflowX: 'hidden',
      overflowY: 'scroll',
      ModalContent:{
        position: 'absolute',
        top: '50%',
        left: '25%',
        transform: 'translate(-50%, -50%) !important',
      },
      ItemContent:{
        slider:{
          margin: '2em 3em 2em 3em',
          width:'30%',
        },
        img:{
          margin: '0.5em'
        },
        info:{
          ...fontFamily,
          padding: '0.5em',
          width:'30%'
        },
        sliderhorizon:{
          margin: '2em'
        },
        imghorizon:{
          padding: '0.5em'
        },
        buttonhorizon:{
          backgroundColor:'rgba(255,100,90,0.65)',
          border: 'solid rgba(255,100,90,1) 0.125em',
          color: 'white',
        },
        txthorizon:{
          ...fontFamily,
          textAlign: 'center'
        },
        infohorizon:{
          margin: '2em 4em 2em 2em'
        },
        h3:{
          ...fontFamily,
          margin: '0.5em 0 0.5em 0',
          fontSize:'1.5em',
          fontWeight: 400,  
        },
        h6:{
          ...fontFamily,
          margin: '0.25em 0 1em 0',
        },
        p:{
          ...fontFamily,
          fontSize:'0.9em',
          fontWeight:200,
        },
        lb:{
          ...fontFamily,
          margin:'1em',

        }
      },
      MenuItem:{
          ...fontFamily,
        backgroundColor:'rgba(255,100,90,0)',
        border: 'none',
        color:'rgba(255,100,90,1)',
      },
      MenuItemActive:{
        ...fontFamily,
        fontWeight: 400,
        backgroundColor:'rgba(255,100,90,0.65)',
        border: 'solid rgba(255,100,90,1) 0.125em',
        color: 'white',
      },

      Pane:{
        ...fontFamily,
        border: 'solid rgba(255,100,90,1) 0.125em',
        borderRadius: '0.5em',
        padding: '1em',
        backgroundColor:'rgba(255,100,90,0.65)',
        color:'white',
        Button:{
          ...fontFamily,
          fontweight: 800,
          margin:'0.25em',
        },
      },

      Form:{
        ...fontFamily,
        
        backgroundColor:'rgba(255,100,90,0)',
        margin: '1em',
        border: 'none',
        boxShadow: 'none',
        Segment:{
          ...fontFamily,
          color: 'white',
          border: 'none',
          backgroundColor:'rgba(255,100,90,0)',
          boxShadow: 'none',
          Input:{
            ...fontFamily,
            color: 'white',
          },  
        }        
      }
    };
    const sliderSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      };
      const sliderHorizonSettings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true
      };

      // RESIZE
    const tabStyleResize = {
      ...fontResize,
      position: 'absolute',
      top: '2.25em',
      left:'5%',
      width: '90%',
      height: '80vh',
      justifyContent: 'center',
      overflowX: 'hidden',
      overflowY: 'scroll',
      ModalContent:{
        width: '90%',
        position: 'absolute',
        top: '50%',
        left: '5%',
        transform: 'translate(-50%, -50%) !important',
        h3:{
          ...fontResize,
          margin: '0.5em 0 0.5em 0',
          fontSize:'1em',
          fontWeight: 400,
        },
        h6:{
          ...fontResize,
          margin: '0.25em 0 1em 0',
        },
        p:{
          ...fontResize,
          fontSize:'0.75em',
          fontWeight: 200,
        },
      },
      ItemContent:{
        slider:{
          position: 'relative',
          margin:'1.5em 1.5em 2em 2em',
          width:'40%',
        },
        sliderUp:{
          position: 'relative',
          margin: '1em 0 1.5em 0',
          left:'20%',
          width:'60%',
        },
        img:{
          margin: '0.5em'
        },
        info:{
          ...fontResize,
          padding: '0.5em',
          width:'40%'
        },
        infoDown:{
          ...fontResize,
          position: 'relative',
          left:'7.5%',
          marginTop:'-15%',
          width:'75%',
        },

        sliderhorizon:{
          margin: '2em',
          marginTop:'-15%',
        },
        imghorizon:{
          padding: '0.5em'
        },
        buttonhorizon:{
          ...fontResize,
          backgroundColor:'rgba(255,100,90,0.65)',
          border: 'solid rgba(255,100,90,1) 0.125em',
          color: 'white',
        },
        txthorizon:{
          ...fontResize,
          textAlign: 'center'
        },
        infohorizon:{
          ...fontResize,
          margin: '2em 4em 2em 2em',
          marginTop:'-15%',
        },

        h3:{
          ...fontResize,
          margin: '0.5em 0 0.5em 0',
          fontSize:'1.75em',
          fontWeight: 400,
        },
        h6:{
          ...fontResize,
          margin: '0.25em 0 1em 0',
        },
        p:{
          ...fontResize,
          fontSize:'1em',
          fontWeight: 200,
        },
        lb:{
          ...fontResize,
          margin:'1em',
        }
      },
      MenuItem:{
        ...fontResize,
        backgroundColor:'rgba(255,100,90,0)',
        border: 'none',
        color:'rgba(255,100,90,1)',
        padding:'0 -2em 0 -2em',
      },
      MenuItemActive:{
        ...fontResize,
        fontWeight: 400, 
         backgroundColor:'rgba(255,100,90,0.65)',
         border: 'solid rgba(255,100,90,1) 0.125em',
         color: 'white',
      },

      Pane:{
        ...fontResize,
        border: 'solid rgba(255,100,90,1) 0.125em',
        borderRadius: '0.5em',
        padding: '1em',
        backgroundColor:'rgba(255,100,90,0.65)',
        color:'white',
        Button:{
          margin:'0.125em',
        },
      },

      Form:{
        ...fontResize,
        backgroundColor:'rgba(255,100,90,0)',
        margin: '1em',
        border: 'none',
        boxShadow: 'none',
        Segment:{
          ...fontResize,
          color: 'white',
          border: 'none',
          backgroundColor:'rgba(255,100,90,0)',
          boxShadow: 'none',
          Input:{
            ...fontResize,
            color: 'white',
          },
          Input2:{
            ...fontResize,
            color: 'white',
          }, 
          Button:{
            ...fontResize,
          }, 
        }        
      }
    };    
export default class TabContent extends Component {

  // STATE
  constructor(props) {
      super(props);
      this.state = {activeTab: 0,
                    openModal:false};
      this.handleTabChange = this.handleTabChange.bind(this);
      //this.handleTabChangeResize = this.handleTabChangeResize.bind(this);
  }

  componentWillReceiveProps({menuactive}) { 
    if (this.props.resize){
      this.loadStateResize(0);
    }else{
      this.loadState(0);
    }
  }

  // MODAL
  showModal = dimmer => e => {
    this.setState({ 
    dimmer, 
    openModal: true,
    activeAccordion: 0, 
    imgIssue:e.currentTarget.getAttribute('data-issue'),
    imgPath: e.currentTarget.getAttribute('data-path'),
    imgFolder:e.currentTarget.getAttribute('data-folder')
  });}
  closeModal = () => this.setState({ openModal: false })


  // EVENT HANDLE
  handleTabChange = (e, data) => {
    e.preventDefault();
    this.setState({activeTab:data.activeIndex},() => {
    }); 
    var ci = contentIndex(this.props.menuactive);
    for(let i = 0;i<data.panes.length;i+=1){
        data.panes[i].menuItem=<Menu.Item style={i== this.state.activeTab?　tabStyle.MenuItemActive :　tabStyle.MenuItem} >{this.props.langactive=='en'?tabContentData[ci][i].titleEn:tabContentData[ci][i].titleTw}</Menu.Item>; 
    }
  }
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeAccordion } = this.state
    const newIndex = activeAccordion === index ? -1 : index

    this.setState({ activeAccordion: newIndex })
  }

  // LOAD
  handleSliderItemsLoad = (path, ref) => {
    var sliderContent=[];
    for(let i = 0; i < ref.length;i+=1){
      sliderContent.push(<div><Item.Image size='medium' src={path + ref[i]} /></div>);
    }
    return sliderContent;    
  }

  handleAccordionLoad  = (lan, path, ref) =>{
    var AccordionContent=[];
    for(let i = 0; i < ref.issueEn.length; i+=1){
      AccordionContent.push(<Grid.Column width={16}><Divider inverted horizontal style={tabStyle.ItemContent.h3} >{lan=='en' ? ref.issueEn[i] : ref.issueTw[i] }</Divider></Grid.Column>);
      AccordionContent.push(  <Grid.Column width={4}>
                                    <Item.Content floated="left" style={tabStyle.ItemContent.infohorizon}>
                                        <Item.Meta style={tabStyle.ItemContent.p}>{lan=='en' ? nl2br(ref.infoEn[i]) : nl2br(ref.infoTw[i])}
                                        </Item.Meta>
                                    </Item.Content>
                              </Grid.Column>);
      AccordionContent.push(  <Grid.Column width={12} verticalAlign="bottom">
                                    <div floated="right" style={tabStyle.ItemContent.sliderhorizon}>
                                      <Slider {...sliderHorizonSettings}>
                                        { this.handleSliderHorizonLoad(
                                          lan,
                                          path,
                                          ref.imgFolder,
                                          ref.imgFolderSub,
                                          [ref.issueEn,ref.issueTw],
                                          [ref.infoEn,ref.infoTw]) }
                                      </Slider>
                                    </div>
                              </Grid.Column>);
    }
    return AccordionContent;
  }
  handleSliderHorizonLoad  = (lan, path, folder, foldersub, issue, info) =>{
    var sliderContent=[];
    for(let i = 0; i < folder.length; i+=1){
      for(let j = 0; j < foldersub.length; j+=1){
        var pathimg = path + folder[i] + foldersub[j] + '/00.jpg';
        sliderContent.push(<div >
                              <Item.Image size='medium'  src={pathimg} style={tabStyle.ItemContent.imghorizon}/>
                              <div style={tabStyle.ItemContent.txthorizon}>
                                <Button basic inverted color="grey" onClick={this.showModal()} data-path={pathimg} data-folder={foldersub[j]} data-issue={lan=='en' ? issue[0][i] : issue[1][i]} style={tabStyle.ItemContent.p}> {foldersub[j]}  </Button>
                              </div>
                           </div>);

        
      }
    }
    return sliderContent;
  }
  handleGalleryHorizonLoad = (type, lan, ref) => {
    var tabContent=[];
    for(let i = 0; i<ref.projects.length; i+=1){
            tabContent.push( 
                <Accordion.Title active={this.state.activeAccordion === i} index={i} onClick={this.handleAccordionClick} style={tabStyle.ItemContent.p}>
                  <Icon name='dropdown' />{lan=='en' ? ref.projects[i].subEn : ref.projects[i].subTw　}
                </Accordion.Title>
              );
           tabContent.push(
                <Accordion.Content active={this.state.activeAccordion === i}>
                  <Grid>
                    { this.handleAccordionLoad( lan, ref.path, ref.projects[i]) }
                  </Grid>
                </Accordion.Content>
            );

    }
    return tabContent;    
  }
  handleLabItemsLoad = (lang, ref) => {
     var itemContent=[];
     for(let i = 0; i < ref.contentEn.length;i+=1){
      itemContent.push(
        <Button animated style={tabStyle.Pane.Button} onClick={()=>{
          window.open(ref.path+ref.contentLink[i]);
        }}>
          <Button.Content visible>{lang=='en' ? ref.contentEn[i] :  ref.contentTw[i] }</Button.Content>
          <Button.Content hidden><Icon name='right arrow' /></Button.Content>
        </Button>);  
     } 
     return itemContent;   
  }
  
  // LOADALL
  loadState = (ref)=> {
      const { menuactive } = this.props;
      const { langactive } = this.props;
      
      const { open, dimmer } = this.state;
      var sv=this.state.activeTab;

      if(ref==null){
      }else{
        this.setState({activeTab:0},()=>{
          sv=this.state.activeTab;
        });
      }

      switch (this.props.menuactive){

      case 'about':
        var tabAbout=[];
        
        // 避免沒有tab可以選
        //this.forceUpdate();


        for(let i=0;i<tabContentData[0].length;i+=1){         
          tabAbout.push({menuItem: <Menu.Item style={i==sv ? tabStyle.MenuItemActive:tabStyle.MenuItem} >{langactive=='en' ? tabContentData[0][i].titleEn :  tabContentData[0][i].titleTw }</Menu.Item>, 
                        render: () => 
                          <Tab.Pane style={tabStyle.Pane} key={i}>
                            <Item style={tabStyle.ItemContent}>
                            <Grid>
                            <Grid.Row>
                            <div floated='left' style={tabStyle.ItemContent.slider}>
                              <Item.Image  size='medium' src={tabContentData[0][i].imgPath} />
                            </div>
                              <Item.Content floated='right' style={tabStyle.ItemContent.info}>
                                  <Item.Header style={tabStyle.ItemContent.h3}>{langactive=='en' ? tabContentData[0][i].titleEn : tabContentData[0][i].titleTw}</Item.Header>
                                  <Item.Meta style={tabStyle.ItemContent.h6}>
                                    <Button circular color='facebook' icon='facebook'  style={tabContentData[0][i].facebook==undefined ? {display: 'none'} : {margin: '0 0.5em 0 0'} } 
                                            onClick={()=>{window.open(tabContentData[0][i].facebook);}}/>
                                    <Button circular color='instagram' icon='instagram'  style={tabContentData[0][i].instagram==undefined ? {display: 'none'} : {margin: '0 0.5em 0 0'} } 
                                            onClick={()=>{window.open(tabContentData[0][i].instagram);}}/>
                                    <Button circular color='google plus' icon='google plus'  style={tabContentData[0][i].googleplus==undefined ? {display: 'none'} : {margin: '0 0.5em 0 0'} } 
                                            onClick={()=>{window.open(tabContentData[0][i].googleplus);}}/>

                                  </Item.Meta>
                                  <Item.Description style={tabStyle.ItemContent.p}>{langactive=='en' ? nl2br(tabContentData[0][i].contentEn) : nl2br(tabContentData[0][i].contentTw)}

                                  </Item.Description>
                                  
                              </Item.Content>
                            </Grid.Row>
                            </Grid>
                            </Item>
                          </Tab.Pane>
                      });
        }
        return tabAbout;
      case 'service':
        var tabService=[];
        //others
        /*
        if (this.state.activeTab >= tabContentData[1].length) {
          this.setState({activeTab: 0});
        }
        */
        for(let i=0;i<tabContentData[1].length;i+=1){
          tabService.push({menuItem: <Menu.Item style={i==this.state.activeTab?tabStyle.MenuItemActive:tabStyle.MenuItem} >{langactive=='en' ? tabContentData[1][i].titleEn :  tabContentData[1][i].titleTw }</Menu.Item>, 
                          render: () => 
                          <Tab.Pane style={tabStyle.Pane} key={i}>
                            <Item style={tabStyle.ItemContent}>
                              <Grid>
                              <Grid.Row>
                              <div style={tabStyle.ItemContent.slider}>
                                <Slider {...sliderSettings}>
                                  { this.handleSliderItemsLoad(tabContentData[1][i].imgPath,tabContentData[1][i].imgFiles)}
                                </Slider>
                              </div>
                              <Item.Content floated='right' style={tabStyle.ItemContent.info}>
                                  <Item.Header style={tabStyle.ItemContent.h3}>{langactive=='en' ? tabContentData[1][i].titleEn : tabContentData[1][i].titleTw}</Item.Header>
                                  <Item.Description style={tabStyle.ItemContent.p}>{langactive=='en' ? nl2br(tabContentData[1][i].contentEn) : nl2br(tabContentData[1][i].contentTw)}</Item.Description>
                                  <Item.Meta style={tabStyle.ItemContent.h6}>
                                    <Label icon={tabContentData[1][i].icon} content={langactive=='en' ? tabContentData[1][i].subEn : tabContentData[1][i].subTw}/>
                                  </Item.Meta>
                              </Item.Content>
                              </Grid.Row>
                              </Grid>
                            </Item>
                          </Tab.Pane>
                        });
        }
        return tabService;
      case 'gallery':
        var tabGallery=[];
        /*
        if (this.state.activeTab >= tabContentData[2].length) {
          this.setState({activeTab: 0});
        }
        */
        for(let i=0;i<tabContentData[2].length;i+=1){
          tabGallery.push({menuItem: <Menu.Item style={i==this.state.activeTab?tabStyle.MenuItemActive:tabStyle.MenuItem} >{langactive=='en' ? tabContentData[2][i].titleEn :  tabContentData[2][i].titleTw }</Menu.Item>, 
                          render: () => 
                          <Tab.Pane style={tabStyle.Pane} key={i}>
                            <Item style={tabStyle.ItemContent}>
                                <Accordion inverted >
                                  { this.handleGalleryHorizonLoad(i,langactive, tabContentData[2][i])}
                                </Accordion>
                            </Item>
                            <Modal dimmer={'blurring'} open={this.state.openModal} onClose={this.closeModal} style={tabStyle.ModalContent} >
                                      <Modal.Header style={tabStyle.ItemContent.h3}>{langactive=='en' ? 'Project Protfolio' : '作品展示'}</Modal.Header>
                                      <Modal.Content image>
                                        <Image wrapped size='medium' src={this.state.imgPath} />
                                        <Modal.Description>
                                          <Header style={tabStyle.ItemContent.h3}>{this.state.imgIssue}</Header>
                                          <p style={tabStyle.ItemContent.p}>{langactive=='en' ? 'Professor: Chi-Fu, Hsiao' : '指導老師：蕭吉甫'}</p>
                                          <p style={tabStyle.ItemContent.p}>{langactive=='en' ? 'Designer：' : '創作者：'}{this.state.imgFolder}</p>
                                        </Modal.Description>
                                      </Modal.Content>
                                      <Modal.Actions>
                                        <Button positive icon='checkmark' labelPosition='right' content={langactive=='en' ? 'Close':'關閉'} onClick={this.closeModal} />
                                      </Modal.Actions>
                            </Modal>
                          </Tab.Pane>
                        });
        }
        return tabGallery;
      case 'lab':
        var tabLab=[];
        /*
        if (this.state.activeTab >= tabContentData[3].length) {
          this.setState({activeTab: 0});
        }
        */
        for(let i=0;i<tabContentData[3].length;i+=1){
        tabLab.push({menuItem: <Menu.Item style={i==this.state.activeTab?tabStyle.MenuItemActive:tabStyle.MenuItem} >{langactive=='en' ? tabContentData[3][i].titleEn :  tabContentData[3][i].titleTw }</Menu.Item>, 
                          render: () => 
                          <Tab.Pane style={tabStyle.Pane} key={i}>
                            <Button.Group vertical >
                            { this.handleLabItemsLoad(langactive, tabContentData[3][i])}
                            </Button.Group>
                          </Tab.Pane>
                        });
        }
        return tabLab;
      case 'contact':
        var tabContact=[];
        /*
        if (this.state.activeTab >= 2) {
          this.setState({activeTab: 0});
        }
        */
            tabContact.push({menuItem: <Menu.Item style={0==this.state.activeTab ? tabStyle.MenuItemActive:tabStyle.MenuItem} >{langactive=='en' ? tabContentData[4][0].titleEn :  tabContentData[4][0].titleTw }</Menu.Item>, 
                          render: () => 
                            <Tab.Pane style={tabStyle.Pane} key={0}>
                              <Form size='large' style={tabStyle.Form}>
                                <Form.Group widths='equal' style={tabStyle.Form.Segment}>
                                  <Form.Field fluid>
                                      <label style={tabStyle.Form.Segment.Input}>{langactive=='en' ? 'Name' : '暱稱'}</label>
                                      <input placeholder={langactive=='en' ? 'Name' : '暱稱'} />
                                  </Form.Field>
                                  <Form.Field fluid>
                                      <label style={tabStyle.Form.Segment.Input}>{langactive=='en' ? 'Interested' : '興趣'}</label>
                                      <Form.Select options={langactive=='en' ? interestOptionEn : interestOptionTw} placeholder={langactive=='en' ? 'Your Interrest...' : '感興趣的題材'} />
                                  </Form.Field>
                                  <Form.Field fluid>
                                      <label style={tabStyle.Form.Segment.Input}>{langactive=='en' ? 'Poffesion' : '身分'}</label>
                                      <Form.Select options={langactive=='en' ? interestOptionEn : interestOptionTw} placeholder={langactive=='en' ? 'Contat us As...' : '您的身分'} />
                                  </Form.Field>
                                </Form.Group>
                                <Form.Field fluid>
                                      <label style={tabStyle.Form.Segment.Input}>{langactive=='en' ? 'Message' : '留言'}</label>
                                      <Form.TextArea placeholder={langactive=='en' ? 'Message Content' : '留言內容'} />
                                </Form.Field>
                                <Form.Field fluid
                                      control={Checkbox}
                                      label={<label style={tabStyle.Form.Segment.Input}>{langactive=='en' ? 'Agree to recieve Subscription' : '同意收到本網站相關動態'} </label>}
                                      />
                                <Form.Button floated="right" inverted color="white">Submit</Form.Button>
                              </Form>
                            </Tab.Pane>
                        });
            tabContact.push({menuItem: <Menu.Item style={1==this.state.activeTab ? tabStyle.MenuItemActive:tabStyle.MenuItem} >{langactive=='en' ? tabContentData[4][1].titleEn :  tabContentData[4][1].titleTw }</Menu.Item>, 
                          render: () => 
                            <Tab.Pane style={tabStyle.Pane} key={1}>
                                <Item.Content floated='left' style={tabStyle.ItemContent.info}>
                                  <Item.Meta style={tabStyle.ItemContent.h6}>
                                    <Label icon='home' content={langactive=='en' ? 'Addrass' : '地址'}/>
                                  </Item.Meta>
                                  <Item.Description style={tabStyle.ItemContent.p}>{langactive=='en' ? nl2br(tabContentData[4][1].addrassEn) : nl2br(tabContentData[4][1].addrassTw)}</Item.Description>
                                </Item.Content>
                                <Item.Content floated='left' style={tabStyle.ItemContent.info}>
                                  <Item.Meta style={tabStyle.ItemContent.h6}>
                                    <Label icon='phone' content={langactive=='en' ? 'Phone' : '連絡電話'}/>
                                  </Item.Meta>
                                  <Item.Description style={tabStyle.ItemContent.p}>{langactive=='en' ? nl2br(tabContentData[4][1].phoneEn) : nl2br(tabContentData[4][1].phoneTw)}</Item.Description>
                                </Item.Content>
                            </Tab.Pane>
            });

            tabContact.push({menuItem: <Menu.Item style={2==this.state.activeTab ? tabStyle.MenuItemActive:tabStyle.MenuItem} >{langactive=='en' ? tabContentData[4][2].titleEn :  tabContentData[4][2].titleTw }</Menu.Item>, 
                          render: () => 
                            <Tab.Pane style={tabStyle.Pane} key={2}>
                            <Button.Group vertical >
                            { this.handleLabItemsLoad(langactive, tabContentData[4][2])}
                            </Button.Group>
                          </Tab.Pane>
            });
        return tabContact;
        
      }
  }

// RESIZE HANDLE
/*
  handleTabChangeResize = (e, data) => {
    var ci = contentIndex(this.props.menuactive);
    for(let i = 0;i<data.panes.length;i+=1){
        data.panes[i].menuItem=<Menu.Item style={i==data.activeIndex ?　tabStyleResize.MenuItemActive :　tabStyleResize.MenuItem} >{this.props.langactive=='en'?tabContentData[ci][i].titleEn:tabContentData[ci][i].titleTw}</Menu.Item>; 
    }
    e.preventDefault();
  }
*/
// LOAD
  handleSliderItemsLoadResize = (path, ref) => {
    var sliderContent=[];
    for(let i = 0; i < ref.length;i+=1){
      sliderContent.push(<div><Item.Image size='medium' src={path + ref[i]} /></div>);
    }
    return sliderContent;    
  }

  handleAccordionLoadResize  = (lan, path, ref) =>{
    var AccordionContent=[];
    for(let i = 0; i < ref.issueEn.length; i+=1){
      AccordionContent.push(<Grid.Column width={16}><Divider inverted horizontal style={tabStyleResize.ItemContent.h3} >{lan=='en' ? ref.issueEn[i] : ref.issueTw[i] }</Divider></Grid.Column>);
      AccordionContent.push(  <Grid.Column width={16}>
                                    <Item.Content floated="left" style={tabStyleResize.ItemContent.infohorizon}>
                                        <Item.Meta style={tabStyleResize.ItemContent.p}>{lan=='en' ? nl2br(ref.infoEn[i]) : nl2br(ref.infoTw[i])}
                                        </Item.Meta>
                                    </Item.Content>
                              </Grid.Column>);
      AccordionContent.push(  <Grid.Column width={16} verticalAlign="bottom">
                                    <div floated="right" style={tabStyleResize.ItemContent.sliderhorizon}>
                                      <Slider {...sliderSettings}>
                                        { this.handleSliderHorizonLoadResize(
                                          lan,
                                          path,
                                          ref.imgFolder,
                                          ref.imgFolderSub,
                                          [ref.issueEn,ref.issueTw],
                                          [ref.infoEn,ref.infoTw]) }
                                      </Slider>
                                    </div>
                              </Grid.Column>);
    }
    return AccordionContent;
  }
  handleSliderHorizonLoadResize  = (lan, path, folder, foldersub, issue, info) =>{
    var sliderContent=[];
    for(let i = 0; i < folder.length; i+=1){
      for(let j = 0; j < foldersub.length; j+=1){
        var pathimg = path + folder[i] + foldersub[j] + '/00.jpg';
        sliderContent.push(<div >
                              <Item.Image size='medium'  src={pathimg} style={tabStyleResize.ItemContent.imghorizon}/>
                              <div style={tabStyleResize.ItemContent.txthorizon}>
                                <Button basic inverted color="grey" onClick={this.showModal()} data-path={pathimg} data-folder={foldersub[j]} data-issue={lan=='en' ? issue[0][i] : issue[1][i]} style={tabStyleResize.ItemContent.p} > {foldersub[j]}  </Button>
                              </div>
                           </div>);

        
      }
    }
    return sliderContent;
  }
  handleGalleryHorizonLoadResize = (type, lan, ref) => {
    var tabContent=[];
    for(let i = 0; i<ref.projects.length; i+=1){
            tabContent.push( 
                <Accordion.Title active={this.state.activeAccordion === i} index={i} onClick={this.handleAccordionClick} style={tabStyleResize.ItemContent.p}>
                  <Icon name='dropdown' />{lan=='en' ? ref.projects[i].subEn : ref.projects[i].subTw　}
                </Accordion.Title>
              );
           tabContent.push(
                <Accordion.Content active={this.state.activeAccordion === i}>
                  <Grid>
                    { this.handleAccordionLoadResize( lan, ref.path, ref.projects[i]) }
                  </Grid>
                </Accordion.Content>
            );

    }
    return tabContent;    
  }

  handleLabItemsLoadResize = (lang, ref) => {
     var itemContent=[];
     for(let i = 0; i < ref.contentEn.length;i+=1){
      itemContent.push(
        <Button animated style={tabStyleResize.Pane.Button} onClick={()=>{
          window.open(ref.contentLink[i]);
        }}>
          <Button.Content visible >{lang=='en' ? ref.contentEn[i] :  ref.contentTw[i] }</Button.Content>
          <Button.Content hidden><Icon name='right arrow' /></Button.Content>
        </Button>);  
     } 
     return itemContent;   
  }  

  // LOADRESIZE
  loadStateResize = (ref)=> { 
      const { menuactive } = this.props;
      const { langactive } = this.props;
      const { open, dimmer } = this.state;
      var sv=this.state.activeTab;

      if(ref==null){
      }else{
        this.setState({activeTab:0},()=>{
          sv=this.state.activeTab;
        });
      }

      const sliderResizeSettings = {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipeToSlide: true,
          rtl:true,

      };  
      switch (this.props.menuactive){
      case 'about':
        var tabAbout=[];
        //initial  
        for(let i=0;i<tabContentData[0].length;i+=1){         
          tabAbout.push({menuItem: <Menu.Item className="about" style={i==this.state.activeTab?tabStyleResize.MenuItemActive:tabStyleResize.MenuItem} >{langactive=='en' ? tabContentData[0][i].titleEn :  tabContentData[0][i].titleTw }</Menu.Item>, 
                        render: () => 
                          <Tab.Pane style={tabStyleResize.Pane}>
                            <Item style={tabStyleResize.ItemContent}>
                            <Grid>
                            <Grid.Row>
                            <div floated='left' style={tabStyleResize.ItemContent.slider}>
                              <Item.Image  size='medium' src={tabContentData[0][i].imgPath} />
                              <Item.Header style={tabStyleResize.ItemContent.h3}>{langactive=='en' ? tabContentData[0][i].titleEn : tabContentData[0][i].titleTw}</Item.Header>
                            </div>
                              <Item.Content floated='right' style={tabStyleResize.ItemContent.info}>
                                  
                                  <Item.Meta style={tabStyleResize.ItemContent.h6}>
                                    <Button size='mini' circular color='facebook' icon='facebook'  style={tabContentData[0][i].facebook==undefined ? {display: 'none'} : {margin: '0 0.5em 0 0'} } 
                                            onClick={()=>{window.open(tabContentData[0][i].facebook);}}/>
                                    <Button size='mini' circular color='instagram' icon='instagram'  style={tabContentData[0][i].instagram==undefined ? {display: 'none'} : {margin: '0 0.5em 0 0'} } 
                                            onClick={()=>{window.open(tabContentData[0][i].instagram);}}/>
                                    <Button size='mini' circular color='google plus' icon='google plus'  style={tabContentData[0][i].googleplus==undefined ? {display: 'none'} : {margin: '0 0.5em 0 0'} } 
                                            onClick={()=>{window.open(tabContentData[0][i].googleplus);}}/>
                                  </Item.Meta>
                                  <Item.Description style={tabStyleResize.ItemContent.p}>{langactive=='en' ? nl2br(tabContentData[0][i].contentEn) : nl2br(tabContentData[0][i].contentTw)}</Item.Description>
                              </Item.Content>
                            </Grid.Row>
                            </Grid>
                            </Item>
                          </Tab.Pane>
                      });
        }
        return tabAbout;
      case 'service':
        var tabService=[];
        for(let i=0;i<tabContentData[1].length;i+=1){
          tabService.push({menuItem: <Menu.Item style={i==this.state.activeTab?tabStyleResize.MenuItemActive:tabStyleResize.MenuItem} >{langactive=='en' ? tabContentData[1][i].titleEn :  tabContentData[1][i].titleTw }</Menu.Item>, 
                          render: () => 
                          <Tab.Pane style={tabStyleResize.Pane}>
                            <Item style={tabStyleResize.ItemContent}>
                              <Grid>
                              <Grid.Row>
                                <div style={tabStyleResize.ItemContent.sliderUp}>
                                  <Slider {...sliderResizeSettings}>
                                    { this.handleSliderItemsLoadResize(tabContentData[1][i].imgPath,tabContentData[1][i].imgFiles)}
                                  </Slider>
                                </div>
                              </Grid.Row>
                              <Grid.Row>
                                <Item.Content style={tabStyleResize.ItemContent.infoDown}>
                                <Grid centered columns={2} padded >
                                <Grid.Row>
                                <Grid.Column >
                                      <Item.Header style={tabStyleResize.ItemContent.h3}>{langactive=='en' ? tabContentData[1][i].titleEn : tabContentData[1][i].titleTw}</Item.Header>
                                      <Item.Extra  >
                                        <Label size='mini' con={tabContentData[1][i].icon} content={langactive=='en' ? tabContentData[1][i].subEn : tabContentData[1][i].subTw} style={tabStyleResize.ItemContent.h6}/>
                                      </Item.Extra>
                                </Grid.Column>
                                <Grid.Column >
                                      <Item.Description  style={tabStyleResize.ItemContent.p}>{langactive=='en' ? nl2br(tabContentData[1][i].contentEn) : nl2br(tabContentData[1][i].contentTw)}</Item.Description>
                                      
                                </Grid.Column>
                                </Grid.Row>
                                </Grid>
                                </Item.Content>
                              </Grid.Row>
                              </Grid>
                            </Item>
                          </Tab.Pane>
                        });
        }
        return tabService;
      case 'gallery':
        var tabGallery=[];
        for(let i=0;i<tabContentData[2].length;i+=1){
          tabGallery.push({menuItem: <Menu.Item style={i==this.state.activeTab?tabStyleResize.MenuItemActive:tabStyleResize.MenuItem} >{langactive=='en' ? tabContentData[2][i].titleEn :  tabContentData[2][i].titleTw }</Menu.Item>, 
                          render: () => 
                          <Tab.Pane style={tabStyleResize.Pane} key={i}>
                            <Item style={tabStyleResize.ItemContent}>
                                <Accordion inverted >
                                  { this.handleGalleryHorizonLoadResize(i,langactive, tabContentData[2][i])}
                                </Accordion>
                            </Item>
                            <Modal dimmer={'blurring'} open={this.state.openModal} onClose={this.closeModal} style={tabStyleResize.ModalContent} >
                                      <Modal.Header style={tabStyleResize.ModalContent.h3}>{langactive=='en' ? 'Project Protfolio' : '作品展示'}</Modal.Header>
                                      <Modal.Content image>
                                        <Image wrapped size='medium' src={this.state.imgPath} />
                                        <Modal.Description>
                                          <Header style={tabStyleResize.ModalContent.h3}>{this.state.imgIssue}</Header>
                                          <p style={tabStyleResize.ModalContent.p}>{langactive=='en' ? 'Professor: Chi-Fu, Hsiao' : '指導老師：蕭吉甫'}</p>
                                          <p style={tabStyleResize.ModalContent.p}>{langactive=='en' ? 'Designer：' : '創作者：'}{this.state.imgFolder}</p>
                                        </Modal.Description>
                                      </Modal.Content>
                                      <Modal.Actions>
                                        <Button positive icon='checkmark' labelPosition='right' content={langactive=='en' ? 'Close':'關閉'} onClick={this.closeModal} />
                                      </Modal.Actions>
                            </Modal>
                          </Tab.Pane>
                        });
        }
        return tabGallery;
      case 'lab':
        var tabLab=[];
        for(let i=0;i<tabContentData[3].length;i+=1){
        tabLab.push({menuItem: <Menu.Item style={i==this.state.activeTab?tabStyleResize.MenuItemActive:tabStyleResize.MenuItem} >{langactive=='en' ? tabContentData[3][i].titleEn :  tabContentData[3][i].titleTw }</Menu.Item>, 
                          render: () => 
                          <Tab.Pane style={tabStyleResize.Pane}>
                            <Button.Group vertical >
                            { this.handleLabItemsLoadResize(langactive, tabContentData[3][i])}
                            </Button.Group>
                          </Tab.Pane>
                        });
        }
        return tabLab;
      case 'contact':
        var tabContact=[];
            tabContact.push({menuItem: <Menu.Item style={tabStyleResize.MenuItemActive} >{langactive=='en' ? tabContentData[4][0].titleEn :  tabContentData[4][0].titleTw }</Menu.Item>, 
                          render: () => 
                            <Tab.Pane style={tabStyleResize.Pane}>
                              <Form size='large' style={tabStyleResize.Form}>
                                <Form.Field fluid>
                                      <label style={tabStyleResize.Form.Segment.Input}>{langactive=='en' ? 'Name' : '暱稱'}</label>
                                      <input  placeholder={langactive=='en' ? 'Name' : '暱稱'} />
                                </Form.Field>
                                <Form.Field fluid>
                                      <label style={tabStyleResize.Form.Segment.Input}>{langactive=='en' ? 'Interested' : '興趣'}</label>
                                      <Form.Select options={langactive=='en' ? interestOptionEn : interestOptionTw} placeholder={langactive=='en' ? 'Your Interrest...' : '感興趣的題材'} />
                                </Form.Field>
                                <Form.Field fluid>
                                      <label style={tabStyleResize.Form.Segment.Input}>{langactive=='en' ? 'Poffesion' : '身分'}</label>
                                      <Form.Select options={langactive=='en' ? porfessionOptionEn : porfessionOptionTw} placeholder={langactive=='en' ? 'Contat us As...' : '您的身分'} />
                                </Form.Field>
                                <Form.Field fluid>
                                      <label style={tabStyleResize.Form.Segment.Input}>{langactive=='en' ? 'Message' : '留言'}</label>
                                      <Form.TextArea placeholder={langactive=='en' ? 'Message Content' : '留言內容'} />
                                </Form.Field>
                                <Form.Group unstackable='true' inline >
                                      <Form.Field fluid
                                          width={12}
                                          control={Checkbox}
                                          style={tabStyleResize.Form.Segment.Input}
                                          label={<label style={tabStyleResize.Form.Segment.Input}>{langactive=='en' ? 'Agree to Subscription' : '同意收到本網站相關動態'}</label>}
                                      />
                                      <Form.Button size="mini" inverted  color='white' style={tabStyleResize.Form.Segment.Button} width={4}>{langactive=='en' ? 'Submit' : '送出'}</Form.Button>
                                </Form.Group>
                              </Form>
                            </Tab.Pane>});
            tabContact.push({menuItem: <Menu.Item style={tabStyleResize.MenuItem} >{langactive=='en' ? tabContentData[4][1].titleEn :  tabContentData[4][1].titleTw }</Menu.Item>, 
                          render: () => 
                            <Tab.Pane style={tabStyleResize.Pane}>
                                <Item.Content floated='left' style={tabStyleResize.ItemContent.info}>
                                  <Item.Meta style={tabStyleResize.ItemContent.h6}>
                                    <Label icon='home' content={langactive=='en' ? 'Addrass' : '地址'}/>
                                  </Item.Meta>
                                  <Item.Description style={tabStyleResize.ItemContent.p}>{langactive=='en' ? nl2br(tabContentData[4][1].addrassEn) : nl2br(tabContentData[4][1].addrassTw)}</Item.Description>
                                </Item.Content>
                                <Item.Content floated='left' style={tabStyleResize.ItemContent.info}>
                                  <Item.Meta style={tabStyleResize.ItemContent.h6}>
                                    <Label icon='phone' content={langactive=='en' ? 'Phone' : '連絡電話'}/>
                                  </Item.Meta>
                                  <Item.Description style={tabStyleResize.ItemContent.p}>{langactive=='en' ? nl2br(tabContentData[4][1].phoneEn) : nl2br(tabContentData[4][1].phoneTw)}</Item.Description>
                                </Item.Content>
                            </Tab.Pane>
                        });
            tabContact.push({menuItem: <Menu.Item style={tabStyleResize.MenuItem} >{langactive=='en' ? tabContentData[4][2].titleEn :  tabContentData[4][2].titleTw }</Menu.Item>, 
                          render: () => 
                            <Tab.Pane style={tabStyleResize.Pane}>
                            <Button.Group vertical >
                            { this.handleLabItemsLoadResize(langactive, tabContentData[4][2])}
                            </Button.Group>
                          </Tab.Pane>
                        });
        return tabContact;
      
      }
  }

  render() {

    if (this.props.resize){
      return(
        <div style={divStyle}>
          <Tab inverted menu={{ fluid: true, vertical: false, tabular: 'top', borderless: true}} 
                style={tabStyleResize}
                panes={this.loadStateResize()}
                onTabChange={this.handleTabChange}
                activeIndex={this.state.activeTab}
                />
        </div>
        );
    }else{
      return(
        <div style={divStyle}>
          <Tab inverted menu={{ fluid: true, vertical: true, tabular: 'right', borderless: true} } 
                style={tabStyle}
                panes={this.loadState()}
                onTabChange={this.handleTabChange}
                activeIndex={this.state.activeTab}
                />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/component/tabContent.jsx